/* AMORA sticky add-to-cart (Milly Grace style). Enhances the theme's own sticky bar, which still submits the main
   product form, so bundles, the free gift and Buy 2 Get 1 behave exactly as they do from the main button.
   Adds: a variant dropdown that drives the main picker, and the price on the button. */
(function () {
  var dataEl = document.getElementById('am-sticky-variants');
  if (!dataEl) return;
  var variants;
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!variants || !variants.length) return;

  function hasBundleWidget() {
    if (dataEl.getAttribute('data-bundle') === '1') return true;
    return Array.prototype.some.call(document.querySelectorAll('main [class*="moon" i], main [id*="moon" i]'), function (el) { return el.offsetHeight > 0; });
  }

  function selectedVariant(formId) {
    var picked = [];
    var inputs = document.querySelectorAll('input[name^="' + formId + '-option"]:checked');
    inputs.forEach(function (i) {
      var pos = parseInt(i.getAttribute('data-option-position') || i.name.split('-option').pop(), 10);
      picked[pos - 1] = i.value;
    });
    if (picked.length) {
      for (var v = 0; v < variants.length; v++) {
        var ok = true;
        for (var o = 0; o < variants[v].options.length; o++) {
          if (picked[o] !== undefined && picked[o] !== variants[v].options[o]) { ok = false; break; }
        }
        if (ok) return variants[v];
      }
    }
    var fromUrl = new URLSearchParams(location.search).get('variant');
    for (var k = 0; k < variants.length; k++) { if (String(variants[k].id) === fromUrl) return variants[k]; }
    for (var a = 0; a < variants.length; a++) { if (variants[a].available) return variants[a]; }
    return variants[0];
  }

  function pickVariant(formId, variant) {
    // Tick every option first, then fire one change event, so the theme re-renders once with the full selection.
    var last = null;
    variant.options.forEach(function (val, idx) {
      var name = formId + '-option' + (idx + 1);
      document.querySelectorAll('input[name="' + name + '"]').forEach(function (input) {
        if (input.value === val && !input.checked) { input.checked = true; last = input; }
      });
    });
    if (last) last.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // Only the button's text is changed, never its markup, so the theme's loading state keeps working.
  function labelNode(btn) {
    var walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = walker.nextNode())) { if (n.nodeValue.trim()) return n; }
    return null;
  }

  function enhance(bar) {
    var formId = bar.getAttribute('form');
    if (!formId) return;
    var current = selectedVariant(formId);
    bar.classList.add('am-satc');

    if (variants.length > 1 && !bar.querySelector('.am-satc__select')) {
      var select = document.createElement('select');
      select.className = 'am-satc__select';
      select.setAttribute('aria-label', 'Choose an option');
      variants.forEach(function (v, i) {
        var opt = document.createElement('option');
        opt.value = String(i);
        opt.textContent = v.title + (v.available ? '' : ' (sold out)');
        if (!v.available) opt.disabled = true;
        select.appendChild(opt);
      });
      select.addEventListener('change', function () { pickVariant(formId, variants[parseInt(select.value, 10)]); });
      var buy = bar.querySelector('buy-buttons');
      if (buy) bar.insertBefore(select, buy); else bar.appendChild(select);
      bar.classList.add('has-am-select');
    }
    var sel = bar.querySelector('.am-satc__select');
    if (sel) sel.value = String(variants.indexOf(current));

    var btn = bar.querySelector('buy-buttons button[type="submit"]');
    if (btn && !btn.disabled) {
      var node = labelNode(btn);
      if (node) {
        var base = btn.getAttribute('data-am-base');
        if (!base) {
          base = node.nodeValue.replace(/\s+/g, ' ').trim();
          btn.setAttribute('data-am-base', base);
        }
        var label = hasBundleWidget() ? base : base + ' – ' + current.price;
        if (node.nodeValue.trim() !== label) node.nodeValue = label;
      }
    }
  }

  function run() { document.querySelectorAll('product-sticky-bar').forEach(enhance); }

  function boot() {
    run();
    document.querySelectorAll('product-rerender[id$="-sticky-bar"]').forEach(function (wrap) {
      new MutationObserver(function () { run(); }).observe(wrap, { childList: true, subtree: true });
    });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('input[name*="-option"]')) setTimeout(run, 60);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
